import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '@/hooks/store'
import { initPostHog, posthog } from '@/setupPostHog'
import { licenseSlice } from '@/store/licenseSlice'

export function usePostHogPageView() {
  const location = useLocation()
  const posthogEnabled = useAppSelector(licenseSlice.selectors.posthogEnabled)

  useEffect(() => {
    if (!posthogEnabled || !initPostHog()) return

    posthog.capture('$pageview', {
      $current_url: window.location.href,
    })
  }, [location.pathname, location.search, posthogEnabled])
}
